(function () {
  "use strict";

  angular
    .module("pub.set_checklist.service", [])
    .factory("SetChecklistsService", SetChecklistsService);

  /** @ngInject */
  function SetChecklistsService($http, $q, API) {
    function list(id, start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/sets/" +
            id +
            "/checklist_definitions?start=" +
            start +
            "&limit=" +
            limit
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      list: list,
    };
  }
})();
